/**
 * Default advertising parameters that are always tracked regardless of preferences
 * These ad params are automatically captured from the URL and stored in sessionStorage,
 * then injected into forms as hidden fields when forms are submitted.
 */
export const DEFAULT_AD_PARAMS = [
	'gclid', // Google Ads click ID
	'dclid', // Google Display & Video 360 click ID
	'fbclid', // Facebook/Meta Ads click ID
	'msclkid' // Microsoft Ads click ID
];

export default DEFAULT_AD_PARAMS;
